import { Stack } from "@mui/material";
import { memo } from "react";
import ScheduleItem from "./NewScheduleItem";
import { INewScheduleListProps } from "./newModels";
import LinkAccessScheduleItem from "../Schedule/LinkAccessScheduleItem";

const NewScheduleList: React.FC<INewScheduleListProps> = ({
  schedules,
  checkInRule,
  isHistoric,
  basePath,
  allowedAction,
}) => {
  return (
    <Stack gap={1} mt={1}>
      {!schedules.isLinkAccess &&
        schedules.data.map((s) => (
          <ScheduleItem
            data={s}
            checkInRule={checkInRule}
            key={s.identifier}
            basePath={basePath}
            allowedAction={allowedAction}
          />
        ))}
      {schedules.isLinkAccess &&
        schedules.data.map((s) => (
          <LinkAccessScheduleItem
            data={s}
            key={s.identifier}
            isHistoric={isHistoric}
          />
        ))}
    </Stack>
  );
};

export default memo(NewScheduleList);
